import { iconLibrary } from '../components/Icon';

export default function getIcons(rating: number): any[] {
  const icons = [];
  for (let i = 0; i < 5; i++) {
    icons.push(i < rating ? iconLibrary.faStar : iconLibrary.farStar);
  }
  return icons;
}